import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DonateComponent } from '../../ui/donate/donate.component';
import { WheelComponent } from '../wheel/wheel.component';
import { SeoService } from '../../services/seo/seo.service';
import { Store } from '@ngrx/store';
import { loadWheelsTemplates } from '../../state';
import { ProfessionalPlanFeaturePromotionComponent } from './ui/professional-plan-feature-promotion/professional-plan-feature-promotion.component';

@Component({
  selector: 'wil-home',
  standalone: true,
  imports: [DonateComponent, WheelComponent, ProfessionalPlanFeaturePromotionComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly seoService = inject(SeoService);

  ngOnInit(): void {
    const { title, description } = this.route.snapshot.data;
    this.seoService.updateSeoTags({
      title,
      description,
    });

    this.store.dispatch(loadWheelsTemplates());
  }
}
